module.exports = __webpack_public_path__ + "static/media/cloud-hail.e2c65617.svg";